import { render, staticRenderFns } from "./RightBox.vue?vue&type=template&id=494b9e9c&scoped=true&"
import script from "./RightBox.vue?vue&type=script&lang=js&"
export * from "./RightBox.vue?vue&type=script&lang=js&"
import style0 from "./RightBox.vue?vue&type=style&index=0&id=494b9e9c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494b9e9c",
  null
  
)

export default component.exports